module.exports = __webpack_public_path__ + "static/img/10.1bb2a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/10.png
// module id = QpzR
// module chunks = 10